import { AuthSession, fetchAuthSession } from 'aws-amplify/auth'

let inFlight: Promise<AuthSession> | null = null

// Amplify v6 does not deduplicate concurrent fetchAuthSession calls
// (github.com/aws-amplify/amplify-js/issues/13499). At app boot many callers fire it
// at once (withLoginState, withLoggedInUserInfo, the Apollo jwtToken per GraphQL
// request); when the cached token needs a refresh they race it and some resolve with
// empty tokens, which surfaces as UserUnAuthenticatedException in fetchUserAttributes.
// Share a single in-flight request instead.
const dedupedFetchAuthSession = (): Promise<AuthSession> => {
  if (!inFlight) {
    inFlight = fetchAuthSession().finally(() => {
      inFlight = null
    })
  }
  return inFlight
}

// Tokens can be transiently empty while a concurrent refresh is in flight; retry once
// before letting callers conclude the user is logged out.
export const fetchAuthSessionReliably = async (): Promise<AuthSession> => {
  const session = await dedupedFetchAuthSession()
  if (session.tokens) return session
  await new Promise(resolve => setTimeout(resolve, 300))
  return dedupedFetchAuthSession()
}
